var map = {
	"./Step1.svg": 1021,
	"./Step2.svg": 1022,
	"./Step3.svg": 1023,
	"./calendar_1week.svg": 1529,
	"./calendar_2weeks.svg": 1530,
	"./calendar_date.svg": 1531,
	"./calendar_hour.svg": 1532,
	"./calendar_month.svg": 1533,
	"./calendar_question.svg": 1534,
	"./continue_brief.svg": 1008,
	"./copy_brief.svg": 1007,
	"./new_brief.svg": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1528;